import { Stack, ToggleButton, Tooltip } from '@mui/material';
import ShowChartIcon from '@mui/icons-material/ShowChart';
import FactCheckOutlinedIcon from '@mui/icons-material/FactCheckOutlined';
import TrashcanIcon from '@mui/icons-material/DeleteOutlined';
import { ReactComponent as CrusherSimulationIcon } from 'icons/crusherSimulation.svg';
import type { ReactNode } from 'react';
import theme from 'theme/theme';
import { useIsExternal } from 'auth/useIsExternal';

interface ActionButtonProps {
  tooltip: string;
  icon: ReactNode;
  onClick: () => void;
}

export const ActionButton = ({ tooltip, icon, onClick }: ActionButtonProps) => {
  return (
    <Tooltip title={tooltip}>
      <ToggleButton
        value={0}
        size='small'
        onClick={onClick}
        sx={{ borderRadius: '50%' }}
      >
        {icon}
      </ToggleButton>
    </Tooltip>
  );
};

interface SidePanelActionBarProps {
  onShowFlowProperties: (() => void) | null;
  onShowReport: (() => void) | null;
  onShowChamberAnalysis: (() => void) | null;
  onDelete: (() => void) | null;
}

export const SidePanelActionBar = ({
  onShowFlowProperties,
  onShowReport,
  onShowChamberAnalysis,
  onDelete,
}: SidePanelActionBarProps) => {
  const isExternal = useIsExternal();

  return (
    <Stack
      direction='row'
      spacing={1}
      sx={{
        justifyContent: 'end',
        marginBottom: theme.spacing(2),
      }}
    >
      {onShowReport && (
        <ActionButton
          tooltip={'Report'}
          onClick={onShowReport}
          icon={<FactCheckOutlinedIcon sx={{ width: 18, height: 18 }} />}
        />
      )}

      {!isExternal && onShowChamberAnalysis && (
        <ActionButton
          tooltip={'Chamber profile viewer'}
          onClick={onShowChamberAnalysis}
          icon={<CrusherSimulationIcon />}
        />
      )}

      {onShowFlowProperties && (
        <ActionButton
          tooltip={'Flow properties'}
          icon={<ShowChartIcon sx={{ width: 18, height: 18 }} />}
          onClick={onShowFlowProperties}
        />
      )}

      {onDelete && (
        <ActionButton
          tooltip={'Delete'}
          icon={<TrashcanIcon />}
          onClick={onDelete}
        />
      )}
    </Stack>
  );
};
